import React from 'react'

const SuccessIcon = () => {
  return (
    <svg
      width="104"
      height="76"
      viewBox="0 0 104 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="24"
        y="10"
        width="56"
        height="56"
        rx="28"
        fill="#5DB594"
        fillOpacity="0.15"
      />
      <mask id="mask0_62_388" x="40" y="26" width="24" height="24">
        <rect x="40" y="26" width="24" height="24" fill="#C4C4C4" />
      </mask>
      <path
        d="M50.6 39.8L48.425 37.625C48.2417 37.4417 48.0167 37.35 47.75 37.35C47.4833 37.35 47.25 37.45 47.05 37.65C46.8667 37.8333 46.775 38.0667 46.775 38.35C46.775 38.6333 46.8667 38.8667 47.05 39.05L49.9 41.9C50.0833 42.0833 50.3167 42.175 50.6 42.175C50.8833 42.175 51.1167 42.0833 51.3 41.9L56.975 36.225C57.1583 36.0417 57.25 35.8167 57.25 35.55C57.25 35.2833 57.15 35.05 56.95 34.85C56.7667 34.6667 56.5333 34.575 56.25 34.575C55.9667 34.575 55.7333 34.6667 55.55 34.85L50.6 39.8ZM52 48C50.6167 48 49.3167 47.7373 48.1 47.212C46.8833 46.6873 45.825 45.975 44.925 45.075C44.025 44.175 43.3127 43.1167 42.788 41.9C42.2627 40.6833 42 39.3833 42 38C42 36.6167 42.2627 35.3167 42.788 34.1C43.3127 32.8833 44.025 31.825 44.925 30.925C45.825 30.025 46.8833 29.3123 48.1 28.787C49.3167 28.2623 50.6167 28 52 28C53.3833 28 54.6833 28.2623 55.9 28.787C57.1167 29.3123 58.175 30.025 59.075 30.925C59.975 31.825 60.6873 32.8833 61.212 34.1C61.7373 35.3167 62 36.6167 62 38C62 39.3833 61.7373 40.6833 61.212 41.9C60.6873 43.1167 59.975 44.175 59.075 45.075C58.175 45.975 57.1167 46.6873 55.9 47.212C54.6833 47.7373 53.3833 48 52 48Z"
        fill="#5DB594"
      />
      <mask id="mask1_62_388" x="80" y="0" width="24" height="24">
        <rect x="80" width="24" height="24" fill="#C4C4C4" />
      </mask>
      <path
        d="M99 9L97.75 6.25L95 5L97.75 3.75L99 1L100.25 3.75L103 5L100.25 6.25L99 9ZM99 23L97.75 20.25L95 19L97.75 17.75L99 15L100.25 17.75L103 19L100.25 20.25L99 23ZM89 20L86.5 14.5L81 12L86.5 9.5L89 4L91.5 9.5L97 12L91.5 14.5L89 20ZM89 15.15L90 13L92.15 12L90 11L89 8.85L88 11L85.85 12L88 13L89 15.15Z"
        fill="#5DB594"
      />
    </svg>
  )
}

export default SuccessIcon
